import React from 'react';
import classNames from 'classnames';
import { Observe } from 'rewire-core';
import { WithStyle } from 'rewire-ui';
import { Theme } from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import CustomFilterModel, { ICustomFilterRow, ICustomFilterRowFormField } from './CustomFilterModel';
import { withStyles } from '../utility/styles';
import OptionsActionMenu from '../ui/OptionsActionMenu';

const styles = (theme: Theme) => ({
  root: {
    margin: '0.75rem 1rem',
  },
  filterGroup: {
    margin: '0 0 1.2rem 0',
    '&:last-child': {
      margin: '0',
    },
  },
  filterRowsContainer: {},
  filterRow: {
    display: 'flex',
    position: 'relative',
    alignItems: 'flex-start',
    marginBottom: '8px',
    paddingRight: '40px',
  },
  filterRowEditorsContainer: {
    width: '100%',
    margin: '0px !important',
    gridTemplateColumns: 'repeat(auto-fit, minmax(85px, 1fr))',
    gridGap: '8px',
  },
  deleteRowButton: {
    minWidth: '0px',
    marginTop: '0.4em',
    marginRight: '10px',
    '&:hover': {
      color: theme.palette.error.main,
    },
  },
  addRowButton: {
    textTransform: 'none',
    minWidth: '145px',
  },
  rowOptionsMenuButton: {
    position: 'absolute',
    right: '5px',
    bottom: 'calc(50% - 5px)',
  },
  headerTitle: {
    fontSize: '22px',
    marginBottom: '12px',
  },
});

interface ICustomFilterViewProps {
  model: CustomFilterModel;
}

type CustomFilterViewProps = WithStyle<ReturnType<typeof styles>, ICustomFilterViewProps>;

class CustomFilterView extends React.PureComponent<CustomFilterViewProps> {
  constructor(props: CustomFilterViewProps) {
    super(props);
  }

  addFilterRow = (group: string) => (_evt: React.MouseEvent) => {
    this.props.model.addGroupFilterRow(group);
  };

  removeFilterRow = (rowId: string) => (_evt: React.MouseEvent) => {
    this.props.model.removeFilterRow(rowId);
  };

  render() {
    return (
      <Observe
        render={() => {
          const { classes, model } = this.props;
          return (
            <div className={classes.root}>
              {model.propertyMapGroups.map((group) => (
                <div className={classes.filterGroup} key={group}>
                  <div className={classes.headerTitle}>{group} Filters</div>
                  <div className={classes.filterRowsContainer}>
                    {model.filterRowsByGroup(group).map((row: ICustomFilterRow) => (
                      <div key={row.id} className={classes.filterRow}>
                        <IconButton className={classes.deleteRowButton} onClick={this.removeFilterRow(row.id)}>
                          <DeleteIcon />
                        </IconButton>
                        <div className={classNames('content', classes.filterRowEditorsContainer)}>
                          <Observe
                            render={() => {
                              const _reloadEditors = row.reloadEditorsToggle;
                              return Object.values(row.data).map((formField: ICustomFilterRowFormField) =>
                                formField.editorField.visible ? (
                                  <formField.editorField.Editor
                                    key={formField.editorField.name}
                                    className={`span${formField.columns}`}
                                  />
                                ) : null,
                              );
                            }}
                          />
                        </div>
                        <Observe
                          render={() => (
                            <>
                              {row.rowOptionsMenuItems?.length ? (
                                <OptionsActionMenu
                                  title="Row Options"
                                  tooltip="Row Options"
                                  items={row.rowOptionsMenuItems}
                                  buttonProps={{ disabled: !model.rowHasEnabledOptions(row) }}
                                  classes={{ menuButton: classes.rowOptionsMenuButton }}
                                />
                              ) : null}
                            </>
                          )}
                        />
                      </div>
                    ))}
                  </div>
                  <Button className={classes.addRowButton} variant="contained" onClick={this.addFilterRow(group)}>
                    <Icon className="add">{'add'}</Icon>
                    Add {group} Filter
                  </Button>
                </div>
              ))}
            </div>
          );
        }}
      />
    );
  }
}

export default withStyles<ICustomFilterViewProps>(styles, CustomFilterView);
